const VARIANTS = {
  black: "bg-site-tile-black text-white",
  surface: "bg-site-surface text-site-ink",
  brand: "bg-omnyx-teal text-white",
};

/**
 * Generic rounded "tile" shell used for every platform / goal card.
 * Pass markup as children so each tile can lay itself out differently.
 */
export default function PlatformTile({
  variant = "surface",
  className = "",
  children,
  ...rest
}) {
  return (
    <div
      className={`relative overflow-hidden rounded-tile ${VARIANTS[variant]} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}
